import { ErrorMessage, useFormikContext } from "formik";
import BsForm from "react-bootstrap/Form";
import { ATTESTATION_TEXTS } from "../constants/sealRegistrationConstants";
import { SealRegistrationFormData } from "../SealRegistrationContext";

export const ProgramAttestationsSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  const toggleAttestation = (index: number) => {
    const updated = [...values.attestationsChecked];
    updated[index] = !updated[index];
    setFieldValue("attestationsChecked", updated);
  };

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Program attestations</h2>
      <p className="form-fields-sub-text" style={{ marginBottom: "18px" }}>
        Please confirm each statement on behalf of the brand or business being
        registered.
      </p>

      {ATTESTATION_TEXTS.map((text, index) => (
        <div key={index} style={{ marginBottom: "16px" }}>
          <BsForm.Check
            label={text}
            className="checkbox-label-text"
            checked={values.attestationsChecked[index] || false}
            onChange={() => toggleAttestation(index)}
          />
        </div>
      ))}
      <ErrorMessage
        name="attestationsChecked"
        className="input-error"
        component="span"
      />

      <div className="seal-terms-box">
        <BsForm.Check
          className="checkbox-label-text"
          checked={values.agreeToTerms}
          onChange={() => setFieldValue("agreeToTerms", !values.agreeToTerms)}
          label={
            <span style={{ fontWeight: 500 }}>
              I agree to the{" "}
              <a href="/seal/guidelines" className="form-fields-sub-text-link">
                OVR Seal Usage Guidelines
              </a>{" "}
              and acknowledge the{" "}
              <a href="/privacy" className="form-fields-sub-text-link">
                Privacy Policy
              </a>
              .
            </span>
          }
        />
        <ErrorMessage
          name="agreeToTerms"
          className="input-error"
          component="span"
        />
      </div>
    </div>
  );
};
